import { createAsyncThunk } from "@reduxjs/toolkit";
import { getCustomers } from "../../services/customer";
import { getSalesVoucherNumber, saveSales, editSales as editSalesService, getTagForSales } from "../../services/sales";
import { getBatchApi } from "../../apiservice/accounts";
import {
  getCustomerSpecialPriceApi,
  getCurrentStockApi,
  getPendingSalesOrderVoucherApi,
  getSalesOrderRecordWithDetailsApi,
  getBatchSerialsApi
} from "../../apiservice/sales";
import { getAccountByTypeApi, getAccountBySeachApi } from "../../apiservice/setting";
import { getproductpackingstructure } from "../../apiservice/inventory";
// Thunk for fetching customer list
export const fetchCustomerList = createAsyncThunk(
  "sales/fetchCustomerList",
  async (searchValue, { rejectWithValue }) => {
    try {
      const response = await getCustomers({
        query: searchValue.trim(),
        type: "debitor",
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// Thunk for fetching sales voucher number and default account

export const fetchSalesVoucherNumber = createAsyncThunk(
  "sales/fetchSalesVoucherNumber",
  async (val, { rejectWithValue }) => {
    try {
      const response = await Promise.all([
        getSalesVoucherNumber({ entryDate: val }),
        getCustomers({
          acc_name: "Cash",
          multiType: ["cash_in_hand"],
        }),
      ]);

      return {
        salesVoucherNumber: response[0].data,
        defaultAccount: response[1].data,
      };
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const createSales = createAsyncThunk(
  "sales/createSales",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await saveSales(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const editSales = createAsyncThunk(
  "sales/editSales",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await editSalesService(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const fetchBatchesForItem = createAsyncThunk(
  "itemAdjustment/fetchBatchesForItem",
  async (payload) => {
    // const payload = {
    //   item_id: itemId,
    //   item_qty: 1,
    // };
    const res = await getBatchApi(payload);
    const formattedData = (res.data || []).map((b) => ({
      id: b.id,
      batch_name: b.batch_name,
      batch_expiry: b.batch_expiry,
      quantity: b.quantity,
      serial_mode: b.serial_mode,
    }));

    return formattedData;
  }
);

// ✅ Keep this — correct one
export const fetchPackingStructureForItem = createAsyncThunk(
  "sales/fetchPackingStructureForItem",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await getproductpackingstructure(payload);

      // Format data for easy use in frontend
      const formattedData = (res.data?.data || []).map((item) =>
        [
          { name: item.std_pack_name, qty: item.std_pack_qty, product_id: item.product_id },
          { name: item.second_pack_name, qty: item.second_pack_qty, product_id: item.product_id },
          { name: item.third_pack_name, qty: item.third_pack_qty, product_id: item.product_id },
          { name: item.fourth_pack_name, qty: item.fourth_pack_qty, product_id: item.product_id },
          { name: item.fifth_pack_name, qty: item.fifth_pack_qty, product_id: item.product_id },
          { name: item.sixth_pack_name, qty: item.sixth_pack_qty, product_id: item.product_id },
        ].filter((pack) => pack.name && pack.name !== "N/A")
      )[0];

      return formattedData || [];
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);


export const fetchSpecialPrices = createAsyncThunk(
  "sales/fetchSpecialPrices",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getCustomerSpecialPriceApi(payload);
      return response.data || [];
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const fetchDiscountAccounts = createAsyncThunk(
  "supplierPayments/fetchDiscountAccounts",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAccountByTypeApi({
        acc_name: "discount on sale",
        acc_type_id: "direct_expense",
      });
      return res.data[0];
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchTaxAccounts = createAsyncThunk(
  "supplierPayments/fetchTaxAccounts",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAccountByTypeApi({
        acc_type_id: "dutie_&_tax",
      });
      return res.data[0];
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchTransportAccounts = createAsyncThunk(
  "supplierPayments/fetchTransportAccounts",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAccountByTypeApi({
        acc_type_id: "direct_income",
      });
      return res.data[0];
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchSalesAccounts = createAsyncThunk(
  "supplierPayments/fetchSalesAccounts",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAccountBySeachApi({
        multiType: ["sale_account"],
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchCurrentStock = createAsyncThunk(
  "supplierPayments/fetchCurrentStock",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await getCurrentStockApi(payload);
      return res.data[0];
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);


export const fetchPendingSalesOrders = createAsyncThunk(
  "sales/fetchPendingSalesOrders",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await getPendingSalesOrderVoucherApi(payload);
      return res.data || [];
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message
      );
    }
  }
);

export const fetchSalesOrderWithDetails = createAsyncThunk(
  "sales/fetchSalesOrderWithDetails",
  async (sale_o_id, { rejectWithValue }) => {
    try {
      const res = await getSalesOrderRecordWithDetailsApi({ sale_o_id });
      return res.data[0] || null;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message
      );
    }
  }
);


export const fetchAvailableTatmeenSerials =
  createAsyncThunk(
    "sales/fetchAvailableSerials",
    async (payload) => {

      const res = await getBatchSerialsApi(payload);

      return res.data || [];
    }
  );
